import { __assign, __rest } from "tslib";
import React from 'react';
import { CardMedia as MaterialCardMedia, } from '@material-ui/core';
export var CardMedia = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(MaterialCardMedia, __assign({}, props), children);
};
//# sourceMappingURL=CardMedia.js.map